import { render, staticRenderFns } from "./mymsg.vue?vue&type=template&id=5afe65bb&scoped=true&"
import script from "./mymsg.vue?vue&type=script&lang=js&"
export * from "./mymsg.vue?vue&type=script&lang=js&"
import style0 from "./mymsg.vue?vue&type=style&index=0&id=5afe65bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe65bb",
  null
  
)

export default component.exports